import React from 'react';
import Microapp from '@/components/micro-app';
import { InjectType } from '@/apis/platform/getMenu';
import Iframe from '@/components/iframe';

// 对于iframe来说，如果path配置为 /a/*
// 访问 /a/b
// 那么iframe的url应该将/b拿出来拼在配置的url之后，
// 如果配置的url是 xxx.jd.com/a 那么就应该是xxx.jd.com/a/b
function computeIframeUrl(path, url) {
  if (!path) return url;
  if (!path.endsWith('/*')) return url;
  // /a/* = /a
  const prefixPath = path.split('/*')[0];
  // 处理 '/*'
  if (!prefixPath) return url;
  // /xxxxx/a/bbb.html
  const pathname = window.location.pathname;
  // [/xxxxx, /bbb.html]
  const pathArr = pathname.split(prefixPath);
  // '/bbb.html'
  const extraPathname = pathArr[pathArr.length - 1];
  if (!extraPathname) return url;

  // 处理 /a/ + /a
  if (url[url.length - 1] === '/' && extraPathname[0] === '/') return url + extraPathname.slice(1);
  // 处理 /a + a
  if (url[url.length - 1] !== '/' && extraPathname[0] !== '/') return url + '/' + extraPathname;
  return url + extraPathname;
}

// {
//   id: 3,
//   name: '内部实现', // 指用于标识，前端不用
//   viewKey: '1000', // 视图key，前端定义
//   jumpType: 3, // 0：无效   1：新开页  2：当前页面刷新 3：当前页面不刷新
//   injectType: 1, //  0：无效   1：内部实现   2： micro   3：iframe   4：外部链接，  100：特殊跳转
//   url: '',
//   path: '',
// },
export default function InjectedCMS({ url, injectType, microName, name, ..._props }) {
  if (injectType === InjectType.micro) return <Microapp name={microName || 'aaa'} url={url} {..._props} />;

  if (injectType === InjectType.iframe) {
    return <Iframe src={computeIframeUrl(_props.path, url)} />;
  }
  return null;
}
